module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash-sidebar"
    },
    on: {
      "click": function($event) {
        _vm.closeControlsidebar(_vm.controlsidebarDisp)
      }
    }
  }, [_c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [(_vm.$router.match('profileimg').name !== '404') ? [_c('router-link', {
    staticClass: "profileimg",
    attrs: {
      "to": {
        name: 'profileimg'
      }
    }
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [(_vm.profileimg !== '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": _vm.profileimg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profileimg === '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "profile-edit img-circle"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  })])])])] : [_c('div', {
    staticClass: "pull-left image"
  }, [(_vm.profileimg !== '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": _vm.profileimg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.profileimg === '') ? _c('img', {
    staticClass: "img-employee img-circle",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  }) : _vm._e()])], _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentUser.username[_vm.nowLang]))]), _vm._v(" "), _c('p', {
    staticClass: "info-detail"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.currentUser.p_coduser))])])], 2), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_vm._l((_vm.modules), function(moduleObj, module, moduleObjIndex) {
    return [(moduleObj.type == 'main_menu') ? [(moduleObj.sequence == '1') ? [_c('li', {
      staticClass: "header header-mini"
    }, [_vm._v("MENU")]), _vm._v(" "), _c('li', {
      staticClass: "header header-lg"
    }, [_vm._v(_vm._s(_vm.mainMenu[_vm.nowLang]))])] : _vm._e(), _vm._v(" "), _c('li', {
      class: {
        active: _vm.currModule == module
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: module
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSidebarMobile()
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: moduleObj.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(moduleObj.name[_vm.nowLang]))])])], 1)] : _vm._e(), _vm._v(" "), (moduleObj.type == 'ess' || (moduleObj.type == 'mss' && (module != 'managerapprove' || (module == 'managerapprove' && moduleObj.codapp.approve.length > 0)))) ? [(moduleObj.type == 'ess' && moduleObj.sequence == 1) ? [_c('li', {
      staticClass: "header header-mini"
    }, [_vm._v("ESS")]), _vm._v(" "), _c('li', {
      staticClass: "header header-lg"
    }, [_vm._v(_vm._s(_vm.menuRequest[_vm.nowLang]))])] : _vm._e(), _vm._v(" "), (moduleObj.type == 'mss' && moduleObj.sequence == 1) ? [_c('li', {
      staticClass: "header header-mini"
    }, [_vm._v("MSS")]), _vm._v(" "), _c('li', {
      staticClass: "header header-lg"
    }, [_vm._v(_vm._s(_vm.menuApprove[_vm.nowLang]))])] : _vm._e(), _vm._v(" "), _c('dash-sidebar-menu', {
      attrs: {
        "moduleObj": moduleObj,
        "module": module,
        "currModule": _vm.currModule,
        "nowLang": _vm.nowLang,
        "fontIcon": _vm.fontIcon,
        "currCodapp": _vm.currCodapp,
        "menu": _vm.menu,
        "rescale": _vm.rescale,
        "version": _vm.version,
        "pcDisp": _vm.pcDisp,
        "closeSidebarMobile": _vm.closeSidebarMobile
      }
    })] : _vm._e()]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11de1304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/DashSidebar.vue
// module id = 3567
// module chunks = 1